import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ToolBarModule } from '@progress/kendo-angular-toolbar';
import { DebounceValueChangeDirective } from './debounce-value-change.directive';

const kendoModules = [ButtonsModule, CommonModule, DateInputsModule, DialogsModule, DropDownsModule, LayoutModule, ToolBarModule];

@NgModule({
  declarations: [DebounceValueChangeDirective],
  imports: kendoModules,
  exports: [...kendoModules, DebounceValueChangeDirective]
})
export class KendoModule {}
